import { render, staticRenderFns } from "./bo-image-category-banner.vue?vue&type=template&id=12d54aae"
import script from "./bo-image-category-banner.vue?vue&type=script&lang=js"
export * from "./bo-image-category-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports